export * as OnlineOrders from './dashboard-page-plugins/2c7daf4b-dbe7-4e00-9ffd-9b44b1884507.js';
export * as RestaurantsMenusManagementMenu from './dashboard-page-plugins/05a202e3-9345-40d3-afa7-92a303baf025.js';
